import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, LogOut, User } from "lucide-react";
import {
  DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Switch } from "../ui/switch";
import { useMoney } from "../../lib/money";
import { ROLE_LABEL } from "../../lib/format";
import { cn } from "../../lib/utils";

const MONEY_OPTIONS = [["cents", "Mostra i centesimi"], ["hidden", "Nascondi gli importi (****)"]];

export function MoneySwitches() {
  const { prefs, toggle } = useMoney();
  return (
    <div className="mt-6 space-y-3 border-t border-border pt-4" data-testid="mobile-money-switches">
      <div className="eyebrow">Importi</div>
      {MONEY_OPTIONS.map(([k, label]) => (
        <label key={k} className="flex items-center justify-between gap-3 px-1 text-sm">
          {label}<Switch checked={prefs[k]} onCheckedChange={() => toggle(k)} data-testid={`mobile-money-${k}-switch`} />
        </label>
      ))}
    </div>
  );
}

export function HideAmountsButton() {
  const { prefs, toggle } = useMoney();
  const Icon = prefs.hidden ? EyeOff : Eye;
  return (
    <button onClick={() => toggle("hidden")} className="p-2.5 rounded-lg hover:bg-accent" title={prefs.hidden ? "Mostra importi" : "Nascondi importi"}
      aria-label={prefs.hidden ? "Mostra importi" : "Nascondi importi"} data-testid="topbar-hide-amounts-btn">
      <Icon className={cn("h-5 w-5", prefs.hidden && "text-amber-400")} />
    </button>
  );
}

export function UserMenu({ user, onLogout }) {
  const nav = useNavigate();
  const { prefs, toggle } = useMoney();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-accent" data-testid="user-menu-btn">
          <div className="h-8 w-8 rounded-full bg-sky-500/20 text-sky-300 flex items-center justify-center text-xs font-bold">{user.first_name[0]}{user.last_name[0]}</div>
          <div className="hidden sm:block text-left leading-tight">
            <div className="text-sm font-medium">{user.full_name}</div>
            <div className="text-[11px] text-amber-400">{ROLE_LABEL[user.role]}</div>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-popover">
        <DropdownMenuLabel className="text-xs text-muted-foreground">{user.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => nav("/profilo")} data-testid="menu-profile"><User className="h-4 w-4 mr-2" />Il mio profilo</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-muted-foreground">Importi</DropdownMenuLabel>
        {MONEY_OPTIONS.map(([k, label]) => (
          <DropdownMenuCheckboxItem key={k} checked={prefs[k]} onCheckedChange={() => toggle(k)} onSelect={(ev) => ev.preventDefault()} data-testid={`menu-money-${k}`}>{label}</DropdownMenuCheckboxItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} className="text-red-400" data-testid="logout-btn"><LogOut className="h-4 w-4 mr-2" />Esci</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
